import { Component, signal, inject, afterNextRender } from '@angular/core';
import { Header } from './header/header';
import { SideMenu } from './side-menu/side-menu';
import { RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { AuthService } from '../auth';
import { NotificationService } from '../shared/services/notification.service';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';

@Component({
  selector: 'app-main',
  imports: [
    Header,
    SideMenu,
    RouterOutlet,
    NotificationDialogComponent,
  ],
  templateUrl: './main.html',
})
export class Main {
  private readonly notificationService = inject(NotificationService);
  readonly #authService = inject(AuthService);

  isSideMenuOpen = signal(false);
  showNotificationPrompt = signal(false);

  constructor() {
    // Logout in another tab, a disabled account or a removed role: back to Login instead of permission errors
    this.#authService.isStaff$
      .pipe(filter((isStaff) => !isStaff), takeUntilDestroyed())
      .subscribe(() => void this.#authService.logout());

    afterNextRender(() => {
      const permission = this.notificationService.notificationPermission();
      const hasAsked = localStorage.getItem('notificationPromptShown');

      if (permission === 'default' && !hasAsked) {
        this.showNotificationPrompt.set(true);
      }
    });
  }

  enableNotifications(): void {
    this.notificationService.requestPermission().subscribe();
    this.dismissNotificationPrompt();
  }

  dismissNotificationPrompt(): void {
    localStorage.setItem('notificationPromptShown', 'true');
    this.showNotificationPrompt.set(false);
  }

  toggleSideMenu(): void {
    this.isSideMenuOpen.update(open => !open);
  }

  closeSideMenu(): void {
    this.isSideMenuOpen.set(false);
  }
}